import Missisipi1 from '../Missisipi/Missisipi (1).webp'
import Missisipi2 from '../Missisipi/Missisipi (2).webp'
import Missisipi3 from '../Missisipi/Missisipi (3).webp'
import Missisipi4 from '../Missisipi/Missisipi (4).webp'
import Missisipi5 from '../Missisipi/Missisipi (5).webp'
import Missisipi6 from '../Missisipi/Missisipi (6).webp'
import Missisipi7 from '../Missisipi/Missisipi (7).webp'
import Missisipi8 from '../Missisipi/Missisipi (8).webp'
import Missisipi9 from '../Missisipi/Missisipi (9).webp'
import Missisipi10 from '../Missisipi/Missisipi (10).webp'


const Missisipiimages =[
Missisipi1,Missisipi2,Missisipi3,Missisipi4,Missisipi5,Missisipi6,Missisipi7,Missisipi8,Missisipi9,Missisipi10
]

export default Missisipiimages;